
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

const state = {
    UpdateTaskList: false,
    TaskDetailList: [],
    TaskFolderList: [],
    PriorityList: [],
    TaskTypeList: [],
    WorkGroupList: [],
    TaskCloseRequestList: [],
    TaskCloseNoMoreData: false,
    TaskListNoMoreData: false,
    taskNo: "",
    TaskAccess: "0",
    serverDateTime: "",
    taskInfo: {},
    Loading: false
};


const getters = {

    GetTaskDetailList(state: any) {
        return state.TaskDetailList;
    },
    GetTaskFolderList(state: any) {
        return state.TaskFolderList;
    },
    GetPriorityList(state: any) {
        return state.PriorityList;
    },

    GetWorkGroupList(state: any) {
        return state.WorkGroupList;
    },
    GetTaskNo(state: any) {
        return state.taskNo;
    },
    GetServerDateTime(state: any) {
        return state.serverDateTime;
    },
    GetTaskCloseRequestList(state: any) {
        return state.TaskCloseRequestList;
    },
    GetTaskInfo(state: any) {
        return state.taskInfo;
    },
    GetTaskCloseNoMoreData(state: any) {
        return state.TaskCloseNoMoreData;
    },
    GetTaskListNoMoreData(state: any) {
        return state.TaskListNoMoreData;
    },
    GetUpdateTaskList(state: any) {
        return state.UpdateTaskList;
    },
    GetTaskAccess(state: any) {
        return state.TaskAccess;
    },
};

const mutations = {

    SetTaskDetailList(state: any, list: any) {
        state.TaskDetailList = list;
    },
    SetTaskFolderList(state: any, list: any) {
        state.TaskFolderList = list;
    },
    AddTaskDetailList(state: any, list: any) {
        state.TaskDetailList = state.TaskDetailList.concat(list);
    },
    SetPriorityList(state: any, list: any) {
        state.PriorityList = list;
    },

    SetWorkGroupList(state: any, list: any) {
        state.WorkGroupList = list;
    },
    SetTaskNo(state: any, no: any) {
        state.taskNo = no;
    },
    SetServerDateTime(state: any, date: any) {
        state.serverDateTime = date;
    },
    SetTaskCloseRequestList(state: any, list: any) {
        state.TaskCloseRequestList = list;
    },
    AddTaskCloseRequestList(state: any, list: any) {
        state.TaskCloseRequestList = state.TaskCloseRequestList.concat(list);
    },
    SetTaskInfo(state: any, item: any) {
        state.taskInfo = item;
    },
    SetTaskCloseNoMoreData(state: any, val: any) {
        state.TaskCloseNoMoreData = val;
    },
    SetTaskListNoMoreData(state: any, val: any) {
        state.TaskListNoMoreData = val;
    },
    SetUpdateTaskList(state: any, val: any) {
        state.UpdateTaskList = val;
    },
    SetTaskAccess(state: any, val: any) {
        state.TaskAccess = val;
    },
};

const actions = {

    GetTaskDetailListFromServer(context: any, Filter: any) {
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("Task/GetTaskDetailsList", {
            params: {
                page: Filter.pageId,
                searchKey: Filter.searchKey,
                orderBy: Filter.orderBy,
                statusIds: Filter.statusIds,
                parentUserId: Filter.parentUserId,
                userTeamTask: Filter.userTeamTask,
                showOnlyMyTask: Filter.showOnlyMyTask,
                searchInDesc: Filter.searchInDesc,
                date: Filter.date,
                preferenceTypeId: Filter.preferenceTypeId,
                taskTypeId: Filter.taskTypeId,
                projectId: Filter.projectId,
                searchInOtherProps: Filter.searchInOtherProps
            }
        })
            .then(data => {

                context.commit("SetLoading", false);
                context.commit('SetUpdateTaskList', false);

                if (data.data.length < 1) {
                    context.commit("SetTaskListNoMoreData", true);
                }
                else {
                    context.commit("SetTaskListNoMoreData", false);
                }
                if (Filter.pageId == 1) {
                    context.commit("SetTaskDetailList", data.data);
                }
                else {
                    context.commit("AddTaskDetailList", data.data);
                }


            });
    },
    GetPriorityListFromServer(context: any) {
        axios.get("Task/GetPriorityList")
            .then(data => {
                context.commit("SetPriorityList", data.data);
            });
    },

    GetTaskFolderListFromServer(context: any, Filter: any) {
        axios.get("Task/GetTaskFoldersByTaskId", {
            params: {
                taskId: Filter.taskId,
                taskFolderId: Filter.taskFolderId
            }
        })
            .then(data => {
                context.commit("SetTaskFolderList", data.data);
            });
    },
    GetWorkGroupListFromServer(context: any, Filter: any) {
        axios.get("Task/GetWorkGroupList", {
            params: {
                text: Filter.text,
                workGroupId: Filter.workGroupId
            }
        })
            .then(data => {
                context.commit("SetWorkGroupList", data.data);
            });
    },
    GetTaskNoFromServer(context: any) {
        axios.get("Task/GetTasksNo")
            .then((data: any) => {
                context.commit("SetTaskNo", data.body);
            });
    },

    GetServerDateTimeFromServer(context: any) {
        axios.get("Task/GetServerDateTime")
            .then(data => {
                context.commit("SetServerDateTime", data.data);
            });
    },
    CloseTaskFolder(context: any, Filter: any) {
        axios.get("TaskCloseRequest/CloseTaskFolder",
            {
                params: {
                    taskFolderId: Filter.taskFolderId
                }
            })
            .then((data: any) => {
                if (data.data == "1" || data.data === "وظيفه مورد نظر بسته شد.") {
                    func.showSuccessMessage("درخواست بستن وظیفه با موفقیت ثبت شد.");
                }
                else {
                    func.showMessage(data.data);
                }
            });
    },
    CreateTask(context: any, loginData: any) {
        context.commit("SetLoading", true);

        axios.post('Task/SimpleTaskCreate', loginData).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.");
                context.commit('SetUpdateTaskList', true);
                setTimeout(function () { router.push('/TaskList'); }, 1500);

            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditTask(context: any, loginData: any) {
        context.commit("SetLoading", true);

        axios.post('Task/SimpleTaskEdit', loginData).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                setTimeout(function () { router.push('/TaskList'); }, 1500);

            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    CreateTaskFolder(context: any, loginData: any) {
        context.commit("SetLoading", true);

        axios.post('Task/SimpleTaskFolderCreate', loginData).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                setTimeout(function () { router.go(-1); }, 1500);

            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    GetTaskInfoFromServer(context: any, Filter: any) {
        axios.get("Task/GetTaskInfo", {
            params: {
                taskId: Filter.taskId,
                taskFolderId: Filter.taskFolderId
            }
        })
            .then(data => {
                context.commit("SetTaskInfo", data.data);
            });
    },
    GetTaskAccess(context: any) {
        axios.get("Task/CanView")
            .then(data => {
                context.commit("SetTaskAccess", data.data);
            });
    },
    GetTaskCloseRequestListFromServer(context: any, Filter: any) {
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("TaskCloseRequest/FilterCloseRequest", {
            params: {
                filterId: Filter.filterId,
                pageId: Filter.pageId,
                applicantUserId: Filter.applicantUserId
            }
        })
            .then(data => {
                context.commit("SetLoading", false);
                if (data.data.length < 1) {
                    context.commit("SetTaskCloseNoMoreData", true);
                    context.commit("SetTaskCloseRequestList", data.data);
                }
                else {
                    context.commit("SetTaskCloseNoMoreData", false);
                    if (Filter.pageId == 1) {
                        context.commit("SetTaskCloseRequestList", data.data);
                    }
                    else {
                        context.commit("AddTaskCloseRequestList", data.data);
                    }
                }


            });
    },
    UpdateCloseRequest(context: any, loginData: any) {
        context.commit("SetLoading", true);

        axios.post('TaskCloseRequest/CloseTask', loginData).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.");
                setTimeout(function () {
                    router.push('/TaskCloseRequestList');
                }, 2000);

            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
